import { useContext } from "react";
import { X } from "lucide-react";
import { RoomItem } from "../../../models/RoomItem";
import { FileIcon } from "../MessageFileItem";
import { UploadFilesContext } from "./MsgAddMorePopover";
import { Util } from "../../../services/Utils/Util";
import { Button } from "../../../components/ui/button";

const InputAddedItemList: React.FC = () => {
  const { items, setItems } = useContext(UploadFilesContext);

  return (<>
    {items.length > 0 && (
      <div className="flex gap-2.5 overflow-x-auto py-2 px-1">
        {items.map((item, i) => getFileItem(item, i))}
      </div>
    )}
  </>)

  function getFileItem(item: RoomItem, index: number) {
    const removeBtn = (
      <Button
        variant="ghost"
        size="icon"
        className="absolute top-1 right-1 h-6 w-6 rounded-full bg-background/80 hover:bg-background shadow-sm z-10"
        onClick={() => removeFile(item)}
      >
        <X className="h-4 w-4 text-card-foreground" />
      </Button>
    );

    return (
      <div key={index} className="relative inline-flex flex-col shrink-0 bg-background rounded-lg border border-border overflow-hidden group">
        {Util.isImageUrl(item.url) ? (
          <div className="relative h-24 w-24">

            <img
              src={item.url}
              title={item.title}
              className="h-full w-full object-cover"
              alt={item.title || "Attached image"}
            />
            {removeBtn}
          </div>
        ) : (
          <div className="relative flex flex-col items-center justify-center p-3 min-w-[100px] h-24">
            <div className="mb-2">
              <FileIcon filename={item.title ?? ""} />
            </div>
            {removeBtn}
            <p className="text-xs text-center truncate max-w-[120px] px-1 text-[color:rgb(var(--text-body))]">
              {item.title}
            </p>

          </div>
        )}
      </div>
    );
  }

  function removeFile(item: any) {
    setItems(items.filter(i => i != item));
  }
}

export default InputAddedItemList;
